import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Header } from '@shared/ui/header';
import { Footer } from '@shared/ui/footer';
import { CLOUDFRONT_LANDING_PAGE_ROOT_URL } from '@shared/config/constants/app';
import DynamicScrollToTop from '@shared/ui/dynamic-scroll-to-top/ui/DynamicScrollToTop';

const welcomeImg = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/welcome-img.webp`;

const Welcome = (activationURL, isPaypal) => {
  const { t } = useTranslation();

  return (
    <article className="welcome-article">
      <DynamicScrollToTop />

      <Header />

      <Container className="container-sm mt-1">
        <section className="welcome-section-1">
          <div className="text-center">
            <img src={welcomeImg} className="img-fluid welcome-img" alt="" />
            <p className="welcome-text-1">{t('welcome_1')}</p>
            <p className="welcome-text-2">{t('welcome_2')}</p>
            <p className="welcome-text-3 mt-1">{t('welcome_4')}</p>
            <p className="welcome-text-3 mt-1 mb-1">{t('welcome_5')}</p>
          </div>
        </section>

        {/* @ts-ignore */}
        <Footer hideFeatures activationURL={activationURL} isOTP={isPaypal} />
      </Container>
    </article>
  );
};

export default Welcome;
